// web-v2/src/services/account-merge.service.js
//
// Account merge (2026-10-29 item 3). The server is the gate (the owner's own Google sign-in) and does all the work: the
// preview is a read of exactly what the confirm would move, and the confirm re-reads it and refuses 409 plan_changed when
// it moved. These only send the fields. Relative imports so a node test can load it.

import { api } from '../lib/api.js';

export const ACCOUNT_MERGE_PATH = '/api/tracon/account-merge';

const EXPECTED = [
  { status: 400, code: 'bad_request' }, { status: 400, code: 'reason_required' }, { status: 403, code: 'owner_only' },
  { status: 404, code: 'not_found' }, { status: 409, code: 'plan_changed' }, { status: 409, code: 'merge_refused' },
  { status: 401, code: 'broker_email_required' }, { status: 409, code: 'not_hidden' },
];

export function getReviewList() {
  return api.get(`${ACCOUNT_MERGE_PATH}/review`, { expected: [{ status: 403, code: 'owner_only' }] });
}

export function getMergePreview(duplicateId, keepId) {
  const q = new URLSearchParams({ duplicate_id: duplicateId, keep_id: keepId }).toString();
  return api.get(`${ACCOUNT_MERGE_PATH}/preview?${q}`, { expected: EXPECTED });
}

export function confirmMerge({ duplicateId, keepId, reason, planHash }) {
  return api.post(`${ACCOUNT_MERGE_PATH}/confirm`, { duplicate_id: duplicateId, keep_id: keepId, reason, plan_hash: planHash }, { expected: EXPECTED });
}

/** "Not a duplicate": hides the pair for good (stored and logged on the server); undo puts it back on the list. */
export function markNotDuplicate(accountIds, reason) {
  return api.post(`${ACCOUNT_MERGE_PATH}/not-duplicate`, { account_ids: accountIds, ...(reason ? { reason } : {}) }, { expected: EXPECTED });
}

export function undoNotDuplicate(accountIds) {
  return api.post(`${ACCOUNT_MERGE_PATH}/not-duplicate/undo`, { account_ids: accountIds }, { expected: EXPECTED });
}
